export default __webpack_public_path__ + "static/media/team2.eaa3d7df.png";